$(document).ready(function(){
  if($('.product-form__cart-submit').attr('aria-disabled') == true) $('.shipping-badge').addClass('hide');
  else $('.shipping-badge').removeClass('hide');
  $('.product-form__cart-submit').on('click', function(){
    if(!$(this).attr('aria-disabled')){
      $('.AddToCartContainer .Cheering').addClass('Show');
    }
    setTimeout(function() {
      $('.AddToCartContainer .Cheering').removeClass('Show');
    }, 1500);
  });

  $('.us-title.block-title').each(function(){
    $(this).on('click', function(){
      if($(this).hasClass('active')){
        $('.us-title.block-title').removeClass('active');
      }else{
        $('.us-title.block-title').removeClass('active');
        $(this).addClass('active');
      }
    });
  });
  
  $('.icon-title').each(function(){
    $(this).on('click', function(){
      if($(this).hasClass('active')){
        $('.icon-title').removeClass('active');
      }else{
        $('.icon-title').removeClass('active');
        $(this).addClass('active');
      }
    });
  });
});

/* P-STASH 2026-10-29 — ATC-Hinweis "Bitte wähle eine Menge"
   Ohne Offer-Auswahl bleibt die Menge 0; der Add-to-Cart läuft dann ins Leere.
   Dieser Block faengt den Fall ab, verhindert den sinnlosen Request und zeigt
   einen Hinweis im Preislisten-CI. Keine Vorauswahl, keine Aenderung am Add selbst. */
(function () {
  var DONE = 'psqBound';
  if (window[DONE]) return;
  window[DONE] = true;

  var GOLD = '#b78c52', INK = '#101010', PAPER = '#f7f4ee';

  var css = ''
    + '@keyframes psq-shake{0%,100%{transform:translateX(0)}18%{transform:translateX(-7px)}36%{transform:translateX(6px)}54%{transform:translateX(-4px)}72%{transform:translateX(2px)}}'
    + '.psq-hint{display:flex;align-items:center;gap:10px;margin:10px 0 0;padding:11px 15px;background:' + INK + ';color:' + PAPER + ';'
    + 'border-left:3px solid ' + GOLD + ';border-radius:2px;font-size:12.5px;line-height:1.35;letter-spacing:.012em;'
    + 'overflow:hidden;animation:psq-grow .3s ease}'
    + '.psq-hint.is-out{animation:psq-shrink .26s ease forwards}'
    + '.psq-hint b{font-weight:700}'
    + '.psq-hint--fixed{position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:2147483000;'
    + 'box-shadow:0 14px 38px rgba(16,16,16,.32);max-width:calc(100vw - 32px)}'
    + '.psq-dot{width:7px;height:7px;border-radius:50%;background:' + GOLD + ';flex:0 0 7px;'
    + 'box-shadow:0 0 0 3px rgba(183,140,82,.25)}'
    + '@keyframes psq-grow{from{transform:translateY(-6px)}to{transform:none}}'
    + '@keyframes psq-shrink{to{opacity:0;transform:translateY(-4px)}}'
    + '.psq-nudge{animation:psq-shake .42s cubic-bezier(.36,.07,.19,.97) both}'
    + '.psq-nudge .qo-card{border-color:' + GOLD + ' !important;box-shadow:0 0 0 1px ' + GOLD + ' inset}'
    + '.psq-nudge .qo-card .qo-title{color:' + GOLD + '}'
    + '.psq-btn-pulse{box-shadow:0 0 0 2px ' + GOLD + ' !important;transition:box-shadow .2s ease}'
    + '@media (prefers-reduced-motion: reduce){.psq-hint{animation:none}.psq-nudge{animation:none}'
    + '.psq-hint.is-out{animation:none;display:none}}'
    + '@media (max-width:600px){.psq-hint{font-size:12px;padding:10px 13px}}';

  var style = document.createElement('style');
  style.setAttribute('data-psq', '1');
  style.appendChild(document.createTextNode(css));
  document.head.appendChild(style);

  function removeHint() {
    var h = document.querySelector('.psq-hint');
    if (h) h.remove();
  }

  // Hinweis sitzt direkt unter dem Mengen-Widget, nicht am Bildschirmrand
  function toast(title, rest) {
    removeHint();
    var offers = document.querySelector('.qo-offers');
    var el = document.createElement('div');
    el.className = 'psq-hint';
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    var dot = document.createElement('span');
    dot.className = 'psq-dot';
    var txt = document.createElement('span');
    var strong = document.createElement('b');
    strong.textContent = title;
    txt.appendChild(strong);
    txt.appendChild(document.createTextNode(rest));
    el.appendChild(dot);
    el.appendChild(txt);
    el.addEventListener('animationend', function (ev) {
      if (ev.animationName === 'psq-shrink') el.remove();
    });
    if (offers && offers.parentNode) {
      offers.insertAdjacentElement('afterend', el);
    } else {
      el.classList.add('psq-hint--fixed');
      document.body.appendChild(el);
    }
    setTimeout(function () {
      el.classList.add('is-out');
      setTimeout(function () { if (el.parentNode) el.remove(); }, 340);
    }, 3600);
  }

  function nudge(button) {
    var offers = document.querySelector('.qo-offers');
    if (offers) {
      offers.classList.remove('psq-nudge');
      void offers.offsetWidth;
      offers.classList.add('psq-nudge');
      setTimeout(function () { offers.classList.remove('psq-nudge'); }, 900);
      try {
        var r = offers.getBoundingClientRect();
        if (r.top < 0 || r.bottom > window.innerHeight) {
          offers.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      } catch (e) {}
    }
    if (button) {
      button.classList.add('psq-btn-pulse');
      setTimeout(function () { button.classList.remove('psq-btn-pulse'); }, 700);
    }
    var txt = (T[lang()] || T.de)();
    toast(txt[0], txt[1]);
  }


  // --- EN: App-Texte des HS Slide Cart uebersetzen (App liefert nur DE) ---
  var HS_EXACT = [
    ['Gl\u00fcckwunsch \uD83C\uDF89! Deine Sendung ist versandkostenfrei!', 'Congrats \uD83C\uDF89! Your order ships free!'],
    ['Das k\u00f6nnte Dir auch gefallen:', 'You might also like:'],
    ['Versand, Steuern und Rabatte werden an der Kasse final berechnet.', 'Shipping, taxes and discounts are calculated at checkout.'],
    ['\uD83D\uDD25 Wir halten deine Bestellung f\u00fcr {{time_remaining}} bereit! \uD83D\uDD25', '\uD83D\uDD25 Your order is reserved for {{time_remaining}} \uD83D\uDD25']
  ];
  var HS_PARTS = [
    ['Wir halten deine Bestellung f\u00fcr', 'Your order is reserved for'],
    ['bereit!', 'left!'],
    ['Deine Sendung ist versandkostenfrei!', 'Your order ships free!']
  ];

  function trHs(t) {
    for (var i = 0; i < HS_EXACT.length; i++) {
      if (t === HS_EXACT[i][0]) return HS_EXACT[i][1];
    }
    var out = t, hit = false;
    for (var j = 0; j < HS_PARTS.length; j++) {
      if (out.indexOf(HS_PARTS[j][0]) !== -1) {
        out = out.split(HS_PARTS[j][0]).join(HS_PARTS[j][1]);
        hit = true;
      }
    }
    return hit ? out : null;
  }

  function translateNode(node) {
    var t = node.nodeValue;
    if (!t || t.length < 6) return;
    var out = trHs(t.trim());
    if (out !== null && out !== t.trim()) node.nodeValue = t.replace(t.trim(), out);
  }

  function jumpstartHs() {
    try {
      var bag = window.HSSLIDECART && window.HSSLIDECART.setSettings && window.HSSLIDECART.setSettings.settings;
      if (!bag) return;
      JSON.stringify(bag, function (k, v) {
        if (typeof v === 'string') { var o = trHs(v); if (o !== null) return o; }
        return v;
      });
      (function walk(o) {
        if (!o || typeof o !== 'object') return;
        for (var k in o) {
          if (!Object.prototype.hasOwnProperty.call(o, k)) continue;
          var v = o[k];
          if (typeof v === 'string') { var o2 = trHs(v); if (o2 !== null) o[k] = o2; }
          else if (v && typeof v === 'object') walk(v);
        }
      })(bag);
    } catch (e) { /* App-Objekt optional */ }
  }

  function watchAppText() {
    var obs = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i];
        if (m.type === 'characterData') translateNode(m.target);
        else if (m.addedNodes) {
          for (var j = 0; j < m.addedNodes.length; j++) {
            var n = m.addedNodes[j];
            if (n.nodeType === 3) translateNode(n);
            else if (n.nodeType === 1) {
              var w = document.createTreeWalker(n, NodeFilter.SHOW_TEXT), t;
              while ((t = w.nextNode())) translateNode(t);
            }
          }
        }
      }
    });
    obs.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  function bootI18n() {
    if (lang() !== 'en') return;
    jumpstartHs();
    watchAppText();
    var w = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT), t;
    while ((t = w.nextNode())) translateNode(t);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(bootI18n, 300); });
  else setTimeout(bootI18n, 300);

  // Keine Vorauswahl: die Seite rendert Karte 1 serverseitig als "is-selected",
  // und der Cart-Sync waehlt je nach Warenkorb erneut eine Karte. Beides wird
  // beim Laden neutralisiert, solange der Kunde nicht selbst gewaehlt hat.
  function clearOffers() {
    if (window.__psqUserChose) return;
    var offers = document.querySelector('.qo-offers');
    if (!offers) return;
    var f = document.querySelector('form[action*="/cart/add"]');
    var q = f && f.querySelector('input[name="quantity"]');
    var sel = String(offers.getAttribute('data-selected-quantity'));
    var anySel = offers.querySelector('.qo-card.is-selected');
    var qtyEmpty = !q || String(q.value) === '0';

    // Nichts zu tun -> verhindert eine MutationObserver-Schleife
    if (sel === '0' && !anySel && qtyEmpty) return;

    offers.querySelectorAll('.qo-card').forEach(function (c) {
      c.classList.remove('is-selected');
      c.setAttribute('aria-pressed', 'false');
    });
    if (sel !== '0') offers.setAttribute('data-selected-quantity', '0');
    if (q && String(q.value) !== '0') { q.value = '0'; q.setAttribute('value', '0'); }
  }

  function markChosen(e) {
    if (e.target && e.target.closest && e.target.closest('.qo-card')) {
      window.__psqUserChose = true;
      removeHint();
    }
  }
  document.addEventListener('pointerdown', markChosen, true);
  document.addEventListener('click', markChosen, true);

  var clearObserver = null;
  function watchOffers() {
    var offers = document.querySelector('.qo-offers');
    if (!offers || (clearObserver && clearObserver.__target === offers)) return;
    if (clearObserver) clearObserver.disconnect();
    clearObserver = new MutationObserver(function () { clearOffers(); });
    clearObserver.__target = offers;
    clearObserver.observe(offers, { attributes: true, attributeFilter: ['data-selected-quantity'] });
  }

  function scheduleClear() {
    [150, 400, 900, 1800, 3200].forEach(function (t) {
      setTimeout(function () { watchOffers(); clearOffers(); }, t);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scheduleClear);
  else scheduleClear();
  window.addEventListener('load', scheduleClear);
  document.addEventListener('shopify:section:load', scheduleClear);

  function lang() {
    var l = (document.documentElement.getAttribute('lang') || '').toLowerCase();
    if (l.indexOf('en') === 0) return 'en';
    if (l.indexOf('de') === 0) return 'de';
    if (location.pathname.indexOf('/en/') === 0 || location.pathname === '/en') return 'en';
    return 'de';
  }

  var T = {
    de: function () { return ['Bitte wähle eine Menge', ' — 1, 2 oder 3 Adventskalender.']; },
    en: function () { return ['Please select a quantity', ' — 1, 2 or 3 Advent Calendars.']; }
  };

  function selectedQty() {
    var offers = document.querySelector('.qo-offers');
    var n = parseInt(offers && offers.getAttribute('data-selected-quantity'), 10);
    if (!isFinite(n)) n = 0;
    return n;
  }

  function isAddButton(el) {
    if (!el || !el.closest) return null;
    var b = el.closest('button[name="add"], [data-add-to-cart], .product-form__cart-submit');
    if (!b) return null;
    var f = b.closest('form');
    if (!f || !f.getAttribute('action') || f.getAttribute('action').indexOf('/cart/add') === -1) return null;
    return b;
  }

  // Klick abfangen, bevor die Slide-Cart-App den Request baut
  document.addEventListener('click', function (e) {
    var btn = isAddButton(e.target);
    if (!btn || !document.querySelector('.qo-offers')) return;
    if (selectedQty() >= 1) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    window.__psqBlock = Date.now();
    nudge(btn);
  }, true);

  // Falls doch ein Request mit Menge 0 rausgeht: abbrechen statt still ins Leere laufen
  function bodyQty(body) {
    try {
      if (body instanceof FormData) return parseInt(body.get('quantity'), 10) || 0;
      if (typeof FormData !== 'undefined' && body && body.constructor === FormData) return parseInt(body.get('quantity'), 10) || 0;
      if (typeof body === 'string') {
        var j = JSON.parse(body);
        if (j && j.items && j.items.length) return parseInt(j.items[0].quantity, 10) || 0;
        if (j && j.quantity !== undefined) return parseInt(j.quantity, 10) || 0;
      }
      if (body && typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) return parseInt(body.get('quantity'), 10) || 0;
    } catch (err) {}
    return null;
  }

  var origFetch = window.fetch;
  if (origFetch) {
    window.fetch = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (url.indexOf('/cart/add') !== -1 && init && init.body) {
          var q = bodyQty(init.body);
          if (q === 0) {
            nudge(isAddButton(document.activeElement) || document.querySelector('form[action*="/cart/add"] button[type="submit"]'));
            return Promise.resolve(new Response('{}', { status: 200, headers: { 'Content-Type': 'application/json' } }));
          }
        }
      } catch (err) {}
      return origFetch.apply(this, arguments);
    };
  }
})();
